








































import {Component, Vue} from "vue-property-decorator";

interface IBadge {
  name: string;
  barcode: string,
  title: string
}

@Component({
  name: "testing-step-3",
})
export default class TestingStep3 extends Vue{
  private PngStep3 = require('@/assets/images/testing/step3.png')

  private badges: Array<IBadge> = [
    {
      name: 'Александр Золоторевский',
      barcode: '1000268514409',
      title: 'посетитель / visitor'
    },
    {
      name: 'Андрей Морозов',
      barcode: '1000268514408',
      title: 'посетитель / visitor'
    },
    {
      name: 'Участник Выставки',
      barcode: '1000268514419',
      title: 'Участник / member'
    }
  ]

  private badgeNum: number = 0;
  private currentBadge: IBadge = this.badges[this.badgeNum];

  nextBadge() {
    this.badgeNum = this.badgeNum < this.badges.length - 1 ? this.badgeNum + 1 : 0;
    this.currentBadge = this.badges[this.badgeNum];
  }
}
